import { AccessDenied } from '@/components/ui/access-denied';
import { useAccessControl } from '@/hooks/useAccessControl';
import RiskCheckModule from '@/modules/risk-check/index';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  page: z.coerce.string().optional(),
  size: z.coerce.string().optional(),
  status: z.coerce.string().optional(),
  startDate: z.coerce.string().optional(),
  endDate: z.coerce.string().optional(),
  dev: z.coerce.string().optional(),
});

export const Route = createFileRoute('/dashboard/risk-check')({
  validateSearch: searchSchema,
  component: RiskCheckPage,
});

function RiskCheckPage() {
  const { canAccessRiskCheck } = useAccessControl();

  if (!canAccessRiskCheck) {
    return <AccessDenied />;
  }

  return <RiskCheckModule />;
}
